import gql from 'graphql-tag';
import { CommentFragment } from '@app/pages/cmms/graphql/cmms-fragments';

export const AddCommentToEntity = gql`
	mutation AddCommentToEntity(
		$objectId: String!
		$objectType: ObjectTypeCase
		$text: String!
		$sendAsEmail: Boolean
		$mentions: [String]
	) {
		createComment(
			objectId: $objectId
			objectType: $objectType
			text: $text
			sendAsEmail: $sendAsEmail
			mentions: $mentions
		) {
			comment {
				...CommentFragment
			}
			success
		}
	}
	${CommentFragment}
`;

export const DeleteComment = gql`
	mutation DeleteComment($commentId: UUID!) {
		deleteComment(commentId: $commentId) {
			success
		}
	}
`;

export const UpdateComment = gql`
	mutation UpdateComment($commentId: String!, $text: String!) {
		updateComment(commentId: $commentId, text: $text) {
			comment {
				...CommentFragment
			}
			success
		}
	}
	${CommentFragment}
`;
